var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"选择素材","visible":_vm.dialogShow,"modal":true,"append-to-body":"","before-close":_vm.onClose,"width":"1000px"}},[_c('img-or-text-material',{attrs:{"is-select-mode":true,"file-type":"news"},on:{"selected":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }